import { inject, InjectionToken } from '@angular/core';
import { Task } from '@jms/model';

/**
 * What the user may do on one task's Detail page. Each app computes it from its own rights and provides
 * {@link TASK_DETAIL_RIGHTS}; the Detail surface reads no right itself, so no party inherits another's rules.
 */
export interface TaskDetailRights {
  /** Change status. Complete and Reopen follow the record lock instead, so an app that opens evidence must also allow them. */
  readonly canManage: boolean;
  /** Name, description, due date, assignee, phase, role and tags. */
  readonly canEditFields: boolean;
  /** Signature, form, files and photos. */
  readonly canAddEvidence: boolean;
  /** Reopen a form already submitted on the task. */
  readonly canModifySubmittedForm: boolean;
}

export const TASK_DETAIL_RIGHTS = new InjectionToken<(task: Task) => TaskDetailRights>('work.task.TASK_DETAIL_RIGHTS');

/** An app that registers no rule opens tasks read-only rather than borrowing another app's rights. */
export const READ_ONLY_TASK_DETAIL_RIGHTS: TaskDetailRights = { canManage: false, canEditFields: false, canAddEvidence: false, canModifySubmittedForm: false };

/** The app's rule, or read-only where the app registered none. */
export function injectTaskDetailRights(): (task: Task) => TaskDetailRights {

  return inject(TASK_DETAIL_RIGHTS, { optional: true }) ?? (() => READ_ONLY_TASK_DETAIL_RIGHTS);
}
